/**
 * BerryPeek
 * Web client for BerryPeek v4
 * @author  biohzrdmx <github.com/biohzrdmx>
 * @copyright Copyright (c) 2022 BerryPeek. All rights reserved
 */

class Uploader {

  init() {
    //
  }
}

export { Uploader };